export default __webpack_public_path__ + "static/logoWithText-a69650ee1f29116f223e18c81228910e.png";